"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _semanticUiReact = require("semantic-ui-react");

var _react = _interopRequireWildcard(require("react"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _colors = _interopRequireDefault(require("../../colors"));

var StyledMenuItem = (0, _reactEmotion.default)(_semanticUiReact.Menu.Item)(function (props) {
  return props.active ? {
    backgroundColor: "".concat(_colors.default.white, " !important"),
    borderBottom: "1px solid ".concat(_colors.default.white),
    borderTop: "4px solid ".concat(_colors.default.blue),
    marginBottom: '-1px',
    padding: '10.5px 0 !important'
  } : {
    backgroundColor: "".concat(_colors.default.inactiveTabColor, " !important")
  };
});

var Menu = function (_PureComponent) {
  (0, _inherits2.default)(Menu, _PureComponent);

  function Menu() {
    (0, _classCallCheck2.default)(this, Menu);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Menu).apply(this, arguments));
  }

  (0, _createClass2.default)(Menu, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_semanticUiReact.Menu, this.props);
    }
  }]);
  return Menu;
}(_react.PureComponent);

exports.default = Menu;
(0, _defineProperty2.default)(Menu, "Header", _semanticUiReact.Menu.Header);
(0, _defineProperty2.default)(Menu, "Item", _semanticUiReact.Menu.Item);
(0, _defineProperty2.default)(Menu, "Menu", _semanticUiReact.Menu.Menu);
(0, _defineProperty2.default)(Menu, "Tab", function (props) {
  return _react.default.createElement(StyledMenuItem, props);
});